import React, { Component } from "react";
import { Portal } from "react-portal";
import {
	EmailShareButton,
	FacebookShareButton,
	LinkedinShareButton,
	PinterestShareButton,
	TwitterShareButton,
} from "react-share";

export default class ProductShare extends Component {
	state = {
		isOpen: false
	}
	handleToggle = () => {
    	this.setState({ isOpen: !this.state.isOpen });
  	};
  	copyCodeToClipboard = () => {
    	const el = this.textArea
		el.select()
		document.execCommand("copy");
		alert('Copied to clipboard');
  	}
	render () {
		return (
			<div>
				<p className="c-product__share" onClick={this.handleToggle}>Share</p>
				<Portal>
					<div className={'c-share-modal ' + (this.state.isOpen ? 'state-open' : "")}>
						<div className="c-share-modal__overlay" onClick={this.handleToggle}></div>
						<div className="c-share-modal__panel">
							<div className="c-share-modal__close" onClick={this.handleToggle}></div>
							<h3 className="c-share-modal__heading">Share</h3>
							<div className="c-share-modal__copy">
								<textarea className="c-share-modal__copy__text" ref={(textarea) => this.textArea = textarea} value={this.props.item.permalink} readOnly />
								<p className="c-share-modal__copy__label">{this.props.item.permalink}</p>
								<button className="c-share-modal__copy__button" onClick={() => this.copyCodeToClipboard()}>Copy</button>
							</div>
							<div className="c-share-modal__buttons">
								<FacebookShareButton className="c-share-modal__button c-share-modal__button--facebook" url={this.props.item.permalink} />
								<TwitterShareButton className="c-share-modal__button c-share-modal__button--twitter" url={this.props.item.permalink} title={this.props.item.heading} />
								<LinkedinShareButton className="c-share-modal__button c-share-modal__button--linkedin" url={this.props.item.permalink} title={this.props.item.heading} />
								<PinterestShareButton className="c-share-modal__button c-share-modal__button--pinterest" url={this.props.item.permalink} media={this.props.item.pinterest} />
								<EmailShareButton className="c-share-modal__button c-share-modal__button--email" url={this.props.item.permalink} subject={this.props.item.heading} body={'Check out ' + this.props.item.heading + ' on the Bloomingdales website.'} />
							</div>
						</div>
					</div>
				</Portal>
			</div>
		);
	}
}